module.exports = __webpack_public_path__ + "img/brochuresmall-min.da0d4c4c.jpg";